import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import InPlaceText from 'components/form/in_place_text';
import InPlaceCheckbox from 'components/form/in_place_checkbox';
import InPlaceSelect from 'components/form/in_place_select';
import { BannerNoticeStore , MembershipTypeStore, BannerNoticeMembershipTypeStore, MembershipGroupStore, BannerNoticeMembershipGroupStore } from '@seedlang/stores';
import { AppUI } from '@seedlang/state';
import InPlaceDatePicker from 'components/form/in_place_date_picker';
import autobind from 'autobind-decorator';
import { isPresent , isBlank } from '@seedlang/utils';
import InfoTooltip from 'components/info_tooltip';
import Spinner from 'components/spinner';
import { Link } from 'react-router';
import BannerNoticeShow from 'components/banner_notice/banner_notice_show';
import WhitelabelOnly from 'utils/whitelabel_only';
import Alert from 'components/alert';
import SeedlangOnly from 'utils/seedlang_only';
import Stack from 'components/layout/stack';
import Grid from 'components/layout/grid';
@observer
class BannerNoticeEdit extends React.Component {

  @computed get bannerNotice() {
    return BannerNoticeStore.showData;
  }

  @computed get hasNoMembershipGroups() {
    if (!this.bannerNotice || !isPresent(this.bannerNotice.bannerNoticeMembershipGroups)) {
      return true;
    }
    return this.bannerNotice.bannerNoticeMembershipGroups.length === 0;
  }

  constructor(props) {
    super(props);
    this.getBannerNotice();
    this.loadMembershipTypes();
    this.loadMembershipGroups();
  }

  @autobind getBannerNotice() {
    BannerNoticeStore.getShow({ids: {bannerNoticeId: this.props.params.bannerNoticeId}});
  }

  @autobind onChange() {
    BannerNoticeStore.getShow({ids: {bannerNoticeId: this.props.params.bannerNoticeId}});
  }

  @autobind loadMembershipTypes() {
    MembershipTypeStore.getIndex({});
  }

  @autobind loadMembershipGroups() {
    MembershipGroupStore.getIndex({});
  }

  @autobind membershipExists(membershipType) {
    if (this.bannerNotice && isPresent(this.bannerNotice.bannerNoticeMembershipTypes)) {
      return this.bannerNotice.bannerNoticeMembershipTypes.find(item => item.membershipType.id === membershipType.id);
    } return false;
  }

  @autobind onToggleMembership(membershipType) {
    if (this.membershipExists(membershipType)) {
      const bannerNoticeMembershipType = this.bannerNotice.bannerNoticeMembershipTypes.find(item => item.membershipType.id === membershipType.id);
      BannerNoticeMembershipTypeStore.destroy({ids: {bannerNoticeMembershipTypeId: bannerNoticeMembershipType.id}}, this.onChange);
    } else {
      BannerNoticeMembershipTypeStore.create({data: {membership_type_id: membershipType.id, banner_notice_id: this.bannerNotice.id}}, this.onChange);
    }
  }

  @autobind membershipGroupExists(membershipGroup) {
    if (this.bannerNotice && isPresent(this.bannerNotice.bannerNoticeMembershipGroups)) {
      return this.bannerNotice.bannerNoticeMembershipGroups.find(item => item.membershipGroup.id === membershipGroup.id);
    } return false;
  }

  @autobind onToggleMembershipGroup(membershipGroup) {
    if (this.membershipGroupExists(membershipGroup)) {
      const bannerNoticeMembershipGroup = this.bannerNotice.bannerNoticeMembershipGroups.find(item => item.membershipGroup.id === membershipGroup.id);
      BannerNoticeMembershipGroupStore.destroy({ids: {bannerNoticeMembershipGroupId: bannerNoticeMembershipGroup.id}}, this.onChange);
    } else {
      BannerNoticeMembershipGroupStore.create({data: {membership_group_id: membershipGroup.id, banner_notice_id: this.bannerNotice.id}}, this.onChange);
    }
  }

  @computed get pathOptions() {
    const options = [];
    if (AppUI.site.signedInHomePageRoute !== AppUI.site.signedOutHomePageRoute) {
      options.push([AppUI.site.signedInHomePageRoute, 'Home (signed in)']);
      options.push([AppUI.site.signedOutHomePageRoute, 'Home (signed out)']);
    } else {
      options.push([AppUI.site.signedInHomePageRoute, 'Home']);
    }
    if (AppUI.site.enableLearningPaths) {
      options.push(['learn.index', 'Learning Paths']);
    }
    options.push(['podcast.index', 'Podcasts']);
    options.push(['videos.index', 'Videos']);
    options.push(['memberships', 'Memberships']);
    return options;
  }

  render() {
    return (
      <Stack gap='sm' alignItems='stretch'>
        <div className='breadcrumbs-wrapper'>
          <div className='breadcrumbs'>
            <Link to={{name: 'creator.banner_notices.index', params: {groupId: AppUI.site.groupId}}}>Banner Notices</Link>
            <i className='fa fa-angle-double-right' />
            <div className='current'>
              {BannerNoticeStore.showData.title}
            </div>
          </div>
        </div>
        <Grid columns={[2,1,1]}>
          <InPlaceText
            legend={<>Title <InfoTooltip>This is not displayed to users, but is used to identify the banner notice in the backend.</InfoTooltip></>}
            defaultValue={BannerNoticeStore.showDataField('title')}
            model='banner_notices'
            field='title'
            id={BannerNoticeStore.showDataField('id')}
          />
          <fieldset>
            <legend>{AppUI.siteIsDefault ? 'Web Published' : 'Published'}</legend>
            {
              !BannerNoticeStore.showData.webPublished &&
                <InfoTooltip icon='warning'>
                  This banner notice has not been published.
                </InfoTooltip>
            }
            <InPlaceCheckbox
              model='banner_notices'
              field='web_published'
              value={BannerNoticeStore.showDataField('webPublished')}
              id={BannerNoticeStore.showDataField('id')}
              afterChange={this.onChange}
            />
          </fieldset>
          <InPlaceCheckbox
              legend='Dismissible'
              model='banner_notices'
              field='dismissible'
              value={BannerNoticeStore.showDataField('dismissible')}
              id={BannerNoticeStore.showDataField('id')}
              afterChange={this.onChange}
          />
        </Grid>
        <SeedlangOnly>
          <InPlaceCheckbox
            legend='Mobile Published'
            model='banner_notices'
            field='mobile_published'
            value={BannerNoticeStore.showDataField('mobilePublished')}
            id={BannerNoticeStore.showDataField('id')}
          />
        </SeedlangOnly>
        <InPlaceText
          richText
          defaultValue={BannerNoticeStore.showDataField('text')}
          model='banner_notices'
          field='text'
          inputType='textarea'
          id={BannerNoticeStore.showDataField('id')}
          afterChange={this.getBannerNotice}
          legend='Text'
        />
        <Grid columns={2}>
          <InPlaceText
            legend='Button Text'
            defaultValue={BannerNoticeStore.showDataField('buttonText')}
            model='banner_notices'
            field='button_text'
            id={BannerNoticeStore.showDataField('id')}
          />
          <fieldset>
            <legend>Button URL</legend>
            <InPlaceText
              defaultValue={BannerNoticeStore.showDataField('url')}
              model='banner_notices'
              field='url'
              id={BannerNoticeStore.showDataField('id')}
            />
            <InPlaceCheckbox
              value={BannerNoticeStore.showDataField('openUrlInNewTab')}
              model='banner_notices'
              field='open_url_in_new_tab'
              id={BannerNoticeStore.showDataField('id')}
              afterChange={this.getBannerNotice}
            >
              Open in new tab
            </InPlaceCheckbox>
          </fieldset>
        </Grid>
        <Grid columns={[1,1,2]}>
          <InPlaceDatePicker
            legend={<>Expire At <InfoTooltip>This banner will be shown until this date.</InfoTooltip></>}
            model='banner_notices'
            field='expire_at'
            value={BannerNoticeStore.showDataField('expireAt')}
            id={BannerNoticeStore.showDataField('id')}
          />
          <InPlaceText
            legend={<># Sessions Until Expiration <InfoTooltip>This banner will be shown this number of time to a user before disappearing.</InfoTooltip></>}
            number
            model='banner_notices'
            field='number_sessions_until_expiration'
            defaultValue={BannerNoticeStore.showDataField('numberSessionsUntilExpiration')}
            id={BannerNoticeStore.showDataField('id')}
          />
          <WhitelabelOnly>
                <fieldset>
                <legend>Page <InfoTooltip>This banner will be shown at the top of the selected page.</InfoTooltip></legend>
                {
                  isBlank(BannerNoticeStore.showData.route) &&
                    <InfoTooltip icon='warning'>
                      This banner notice has not been assigned to a page.
                    </InfoTooltip>
                }
                <InPlaceSelect
                  includeBlank
                  model='banner_notices'
                  field='route'
                  options={this.pathOptions}
                  afterChange={this.onChange}
                  value={BannerNoticeStore.showDataField('route')}
                  id={BannerNoticeStore.showDataField('id')}
                />
              </fieldset>
          </WhitelabelOnly>
        </Grid>
        <WhitelabelOnly>
          <fieldset>
            <legend>Payment Migration Status</legend>
            <InPlaceSelect
              includeBlank
              model='banner_notices'
              field='payment_migration_status'
              options={[
                ['stripe_payment_setup_started', 'Credit Card Details Started, But Not Completed'],
                ['waiting_for_patreon_cancellation', 'Credit Card Details Completed, Waiting for Cancellation'],
                ['waiting_for_patreon_expiry', 'Patreon Cancelled, Waiting for Expiration'],
                ['completed', 'Migration Complete'],
              ]}
              afterChange={this.onChange}
              value={BannerNoticeStore.showDataField('paymentMigrationStatus')}
              id={BannerNoticeStore.showDataField('id')}
            />
          </fieldset>
          <Grid columns={2}>
            <Stack gap='xs' as='fieldset'>
              <legend>Membership Types</legend>
              {
                MembershipTypeStore.hasOutstandingRequests &&
                  <Spinner />
              }
              <InPlaceCheckbox
                id={this.bannerNotice.id}
                value={this.bannerNotice.showToSignedOutUser}
                afterChange={this.getBannerNotice}
                model='banner_notices'
                field='show_to_signed_out_user'
              >
                Signed Out Users
              </InPlaceCheckbox>
              <InPlaceCheckbox
                id={this.bannerNotice.id}
                value={this.bannerNotice.showToNonMembers}
                afterChange={this.getBannerNotice}
                model='banner_notices'
                field='show_to_non_members'
              >
                Signed In Users with No Membership
              </InPlaceCheckbox>
              {
                MembershipTypeStore.indexData.map(item => {
                  return (
                    <div key={item.id}>
                      <InPlaceCheckbox
                        value={this.membershipExists(item)}
                        onChange={() => this.onToggleMembership(item)}
                      >
                        {item.name}
                      </InPlaceCheckbox>
                    </div>
                  );
                })
              }
            </Stack>
            <fieldset>
              <legend>Membership Groups</legend>
              {
                BannerNoticeStore.hasOutstandingRequests || MembershipGroupStore.hasOutstandingRequests ?
                  <Spinner /> :
                  <Stack gap='xs'>
                    {
                      MembershipGroupStore.indexData.map(item => {
                        return (
                          <div key={item.id}>
                            <InPlaceCheckbox
                              value={this.membershipGroupExists(item)}
                              onChange={() => this.onToggleMembershipGroup(item)}
                            >
                              {item.name}
                            </InPlaceCheckbox>
                          </div>
                        );
                      })
                    }
                    {
                      this.hasNoMembershipGroups &&
                        <Alert type='warning'>
                          No membership groups selected. This banner notice will not be visible to any users.
                        </Alert>
                    }
                  </Stack>
              }
            </fieldset>
          </Grid>
        </WhitelabelOnly>
        <div className='backend-title'>
          Preview
          <InfoTooltip>
            <div>This is a preview of the banner notice.</div>
            <div>It would appear at the top of the selected page.</div>
          </InfoTooltip>
        </div>
        {
          BannerNoticeStore.hasShowData &&
            <BannerNoticeShow
              bannerNotice={BannerNoticeStore.showData}
              preview
            />
        }
      </Stack>
    );
  }
}

export default BannerNoticeEdit;
